<template>
  <modal
    :title="modalTitle"
    :open="isOpen"
    :saveText="modalSaveText"
    @save="fileUpload"
    @cancel="cancel"
  >
    <div class="user-xls-invite">
      <p>
        {{$t('ui.users.xls_invite_description')}}
      </p>
      <p>
        {{$t('ui.users.xls_invite_format')}}
      </p>
      <div class="xls-upload">
        <upload-field @change="fileChange"/>
      </div>
      <div class="errors" v-if="error">
        <p>
          {{error}}
        </p>
      </div>
    </div>
  </modal>
</template>
<script>
import UploadField from '@/components/helpers/DataInput/UploadField'
import User from '@/api/User'
import { EventBus } from '@/EventBus.js';
import Modal from '@/components/helpers/Layout/NewModal'

export default{
  components: {
    UploadField,
    Modal
  },
  data(){
    return {
      file: null,
      error: '',
      isOpen: false
    }
  },
  computed: {
    modalSaveText() {
      return this.$t('ui.button.users.upload_xls')
    },
    modalTitle() {
      return this.$t('ui.users.xls_invite')
    }
  },
  mounted() {
    EventBus.$on('action', this.handleAction);
  },
  methods: {
    fileChange(payload){
      this.file = payload
      this.error = ''
    },
    fileUpload(){
      let formData = new FormData();
      formData.append('xls_file', this.file);
      let user = new User()
      user.inviteXls(formData, this.$i18n.locale).then((response)=>{
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'ui.users.invite_xls_success',
          'type': 'success'
        })
        this.isOpen = false
        this.error = ''
        EventBus.$emit('action','user_invited')
      }).catch((e)=>{
        this.error = this.$t("errors.users.xls_import.wrong_file")
        this.$store.commit('SET_NOTIFICATION', {
          'title': this.error,
          'type': 'error'
        })
      })
    },
    handleAction(action){
      if(action == "users.invite_xls"){
        this.error = ''
        this.isOpen = true
      }
    },
    cancel() {
      this.isOpen = false
      this.error = ''
    }
  },
}
</script>
<style lang="sass">
.user-xls-invite
  p
    color: $ink-light

  .actions
    text-align: right
    display: block

  .errors
    padding: 10px
    background-color: #ffbdbd
    color: #5d2e2e
</style>



// WEBPACK FOOTER //
// UserXlsInvite.vue?60e238a6